import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const CategoryCard = ({ id, title, imageSrc, description }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      whileHover={{ y: -8 }}
      transition={{ type: "spring", stiffness: 300, damping: 25 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      onClick={() => navigate(`/category/${id}`)}
      className="relative cursor-pointer rounded-3xl overflow-hidden group bg-white shadow-lg hover:shadow-2xl transition-all duration-500 w-full h-[320px] [transform:translateZ(0)] [-webkit-mask-image:-webkit-radial-gradient(white,black)]"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={imageSrc}
          alt={title}
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay - darker at bottom for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
      </div>

      {/* Content - positioned at bottom */}
      <div className="absolute bottom-0 left-0 right-0 p-6 z-10">
        <motion.h3
          animate={{ y: isHovered ? -5 : 0 }}
          className="text-2xl font-bold text-white mb-2 drop-shadow-lg"
        >
          {title}
        </motion.h3>

        {/* Description - shows on hover */}
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{
            opacity: isHovered ? 1 : 0,
            height: isHovered ? 'auto' : 0
          }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden"
        >
          <p className="text-white/90 text-sm mb-3 line-clamp-2">
            {description || `Explore professional services in ${title}`}
          </p>

          <div className="inline-flex items-center gap-2 text-white font-medium text-sm">
            <span>Explore</span>
            <ArrowRight className="w-4 h-4" />
          </div>
        </motion.div>

        {/* Hover indicator when not hovered */}
        {!isHovered && (
          <div className="text-white/70 text-xs mt-1 flex items-center gap-2">
            <span className="w-6 h-0.5 bg-white/50"></span>
            <span>Hover to learn more</span>
          </div>
        )}
      </div>

      {/* Top right corner accent */}
      <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <ArrowRight className="w-5 h-5 text-white" />
      </div>
    </motion.div>
  );
};

export default CategoryCard;
